import { REACT_APP_SSO_URL } from '../utils/config';

const API_KEY = process.env.REACT_APP_API_KEY;
const SSO_URL = REACT_APP_SSO_URL;
const SSO_LOGOUT_URL = `${REACT_APP_SSO_URL}/logout`;
export { API_KEY, SSO_URL, SSO_LOGOUT_URL };
